import { session } from 'wix-storage';
import { openLightbox, formFactor } from 'wix-window';
import { downloadPDF } from 'backend/pdf';
import { set, getOr } from 'lodash/fp';
import { fetch } from 'wix-fetch';
import wixLocation from 'wix-location';
import { sendBiEvent } from 'public/biSender';

const DEBUG_LOG = false;

const BUTTON = 'button';
const TEXT_INPUT = 'textInput';

const initComponentsProp = {
    'button5': { type: BUTTON, biName: 'create_your_invoice', link: '/home#anchor2' },
    'button12': { type: BUTTON, biName: 'invoice_generator_sign_in', link: 'https://wix.com/my-account/sites' },
    // 'button4': { type: BUTTON, biName: 'find_out_more', link: '/home#anchor1' },
    'button3': { type: BUTTON, biName: 'view_sample_invoice', link: 'https://0df82b45-b6fa-4c75-81e0-d9643721a27e.filesusr.com/ugd/91bb0b_0f89a2ac5db840c4afda26571695008a.pdf' },
    //'uploadButton': {biName: 'open_upload_image_info'},
    'businessName': { type: TEXT_INPUT, biName: 'start_business_form_info' },
    'clientName': { type: TEXT_INPUT, biName: 'start_client_form_info' },
    'invoiceNumber': { type: TEXT_INPUT, biName: 'start_invoice_settings_form_info' },
    'addTaxbutton': { type: BUTTON, biName: 'apply_tax_info', onClickFunc: addTaxbutton_click },
    'addNewProduct': { type: BUTTON, biName: 'apply_billing_items_info', onClickFunc: addNewProduct_click },
    'balancButton': { type: BUTTON, biName: 'update_balance_info', onClickFunc: balancButton_click },
    'notes': { type: TEXT_INPUT, biName: 'start_typing_notes_info' },
    'terms': { type: TEXT_INPUT, biName: 'start_typing_terms_info' },
    'downLoadInvoiceButton': { type: BUTTON, biName: 'download_invoice', onClickFunc: downLoadInvoiceButton_click },
}
const taxesArray = [];
const productsArray = [];
let imgUrl;
let ifUpdateBalanace = '';

let siteURL;
const NAME = 'invoice';

$w.onReady(() => {
    try {
        for (let componentName in initComponentsProp) {
            if (initComponentsProp[componentName].type === BUTTON) {
                $w(`#${componentName}`).onClick(async (event) => {
                    await sendBiEvent(initComponentsProp[componentName].biName);
                    if (initComponentsProp[componentName].link)
                        wixLocation.to(initComponentsProp[componentName].link);
                    if (initComponentsProp[componentName].onClickFunc)
                        initComponentsProp[componentName].onClickFunc();
                });
            } else if (initComponentsProp[componentName].type === TEXT_INPUT) {
                $w(`#${componentName}`).onFocus(async (event) => {
                    await sendBiEvent(initComponentsProp[componentName].biName);
                });
            }
        }
    } catch (error) {
        console.log("error in onReady!!!", error);
    }

});

const FIELD_IDS = {
    BUSINESS_NAME: 'businessName',
    BUSINESS_EMAIL: 'businessEmail',
    BUSINESS_ADDRESS: 'businessAddress',
    BUSINESS_COUNTRY: 'businessCountry',
    BUSINESS_STATE: 'businessState',

    CLIENT_NAME: 'clientName',
    CLIENT_EMAIL: 'clientEmail',
    CLIENT_ADDRESS: 'clientAddress',
    CLIENT_COUNTRY: 'clientCountry',
    CLIENT_STATE: 'clientState',

    DUE_DATE: 'dueDate',
    DATE_OF_ISSUE: 'dateOfIssue',
    INVOICE_CURRENCY: 'invoiceCurrency',

    BULLING_PRODUCT_ITEM: 'billingProductItem',
    BILLING_DESCRIPTION: 'billingDescription',
    BILLING_PRICE: 'billingPrice',
    BILLING_QUANTITY: 'billingQuantity',
    BILLING_DISCOUNT: 'billingDiscount',
    BILLING_DISCOUNT_CALCULATION: 'billingDiscountCalculation',
    BILLING_LINE_TOTAL: 'billingLineTotal',
    BILLING_TAX: 'billingTax',
    BILLING_SUB_TOTAL: 'billingSubTotal',

    INVOICE_NUMBER: 'invoiceNumber',
    INVOICE_TAX_TYPE: 'invoiceTaxType',
    INVOICE_TAX_RATE: 'invoiceRate',

    BALANCE: 'balance',
    NOTES: 'notes',
    TERMS: 'terms',

    UPLOAD: 'uploadButton',
};

function generateId() {
    return Date.now().toString();
}

function getElement(elementId) {
    return $w(`#${elementId}`);
}

function checkLimit1to99(field) {
    const value = getOr(0, 'value', getElement(field));

    if (value >= 1 && value <= 99) {
        return true;
    }

    return false;
}

function checkLimit1(field) {
    const value = getOr(0, 'value', getElement(field));

    if (value >= 1) {
        return true;
    }

    return false;
}

function checkLimits() {
    return (
        checkLimit1(FIELD_IDS.BILLING_PRICE) &&
        checkLimit1(FIELD_IDS.BILLING_QUANTITY) &&
        checkLimit1to99(FIELD_IDS.BILLING_DISCOUNT) &&
        checkLimit1to99(FIELD_IDS.INVOICE_TAX_RATE)
    );
}

function showValidation(elementToBlur) {
    // getElement(elementToBlur).style.borderColor = 'red';
    const element = getElement(elementToBlur);
    element.updateValidityIndication();
}

function hideValidation(elementToBlur) {
    getElement(elementToBlur).style.borderColor = '#A9A9A9';
}

function checkValidation() {
    const fieldsArray = [
        FIELD_IDS.BUSINESS_NAME,
        FIELD_IDS.BUSINESS_EMAIL,
        FIELD_IDS.CLIENT_NAME,
        FIELD_IDS.CLIENT_EMAIL,
        FIELD_IDS.INVOICE_NUMBER,
        FIELD_IDS.DATE_OF_ISSUE,
        FIELD_IDS.DUE_DATE,
        FIELD_IDS.INVOICE_CURRENCY,
        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
    ];

    return fieldsArray.reduce((accumulator, field) => {
        // Check if previous value is already set to false, skip checking

        if (!accumulator) {
            return false;
        }

        // Check values
        const element = getElement(field);

        if (element.required && !element.valid) {
            // if (field !== FIELD_IDS.DUE_DATE && field !== FIELD_IDS.DATE_OF_ISSUE) {
            element.scrollTo();
            showValidation(field);
            // }

            return false;
        }

        return accumulator;
    }, true);

}

function checkValidationForSpecialChars() {
    const fieldsArray = [

        FIELD_IDS.BUSINESS_NAME,
        FIELD_IDS.BUSINESS_EMAIL,
        FIELD_IDS.BUSINESS_ADDRESS,
        FIELD_IDS.BUSINESS_COUNTRY,
        FIELD_IDS.BUSINESS_STATE,

        FIELD_IDS.CLIENT_NAME,
        FIELD_IDS.CLIENT_EMAIL,
        FIELD_IDS.CLIENT_ADDRESS,
        FIELD_IDS.CLIENT_COUNTRY,
        FIELD_IDS.CLIENT_STATE,

        FIELD_IDS.DUE_DATE,
        FIELD_IDS.DATE_OF_ISSUE,
        FIELD_IDS.INVOICE_CURRENCY,

        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
        FIELD_IDS.BILLING_DISCOUNT,
        FIELD_IDS.BILLING_DISCOUNT_CALCULATION,
        FIELD_IDS.BILLING_LINE_TOTAL,
        FIELD_IDS.BILLING_TAX,
        FIELD_IDS.BILLING_SUB_TOTAL,

        FIELD_IDS.INVOICE_NUMBER,
        FIELD_IDS.INVOICE_TAX_TYPE,
        FIELD_IDS.INVOICE_TAX_RATE,
        FIELD_IDS.NOTES,
        FIELD_IDS.TERMS,
    ];

    let re = /[`~&<>;/[\]|{}=`]/;

    for (let field of fieldsArray) {
        console.log('field', field);
        const element = getElement(field);
        const value = element.value;
        const test = re.test(value); // if value has a special characters the validation should not pass
        console.log('test', field, test);
        if (test === true) {
            return false
        }
    }

    return true;
}

function checkValidationBilling() {

    const fieldsArray = [
        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
    ];

    return fieldsArray.reduce((accumulator, field) => {
        // Check if previous value is already set to false, skip checking

        if (!accumulator) {
            return false;
        }

        // Check values
        const element = getElement(field);

        if (element.required && !element.valid) {
            showValidation(field);
            return false;
        }

        return accumulator;
    }, true);

}

function checkBillingFields() {
    const fieldsArray = [
        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
        FIELD_IDS.BILLING_LINE_TOTAL,
    ];

    return fieldsArray.reduce((accumulator, field) => {

        // Check if previous value is already set to false, skip checking
        if (!accumulator) {
            return false;
        }

        // Check values
        if (getElement(field).value === '') { // if one not good enter
            if (ifUpdateBalanace === '') {
                showValidation(field);
                return false;
            }

            return true;
        }
        hideValidation(field);

        return accumulator;
    }, true);
}

function checkTaxFields() {
    const fieldsArray = [FIELD_IDS.INVOICE_TAX_TYPE, FIELD_IDS.INVOICE_TAX_RATE];

    return fieldsArray.reduce((accumulator, field) => {
        // Skip checks.
        if (accumulator) {
            return true;
        }

        // Check for empty value & range check
        if (getElement(field).value === '' || !checkLimits()) {
            if (ifUpdateBalanace === '') {
                showValidation(field);

                return false;
            }

            return true;
        }
        hideValidation(field);

        return accumulator;
    }, false);
}

function createPdfObjectData() {
    const { value: dueDate } = getElement(FIELD_IDS.DUE_DATE);
    const { value: dateOfIssue } = getElement(FIELD_IDS.DATE_OF_ISSUE);
    const templates = [
        { key: 'businessName', elementId: FIELD_IDS.BUSINESS_NAME },
        { key: 'businessEmail', elementId: FIELD_IDS.BUSINESS_EMAIL },
        { key: 'businessAddress', elementId: FIELD_IDS.BUSINESS_ADDRESS },
        { key: 'businessCountry', elementId: FIELD_IDS.BUSINESS_COUNTRY },
        { key: 'businessState', elementId: FIELD_IDS.BUSINESS_STATE },
        { key: 'clientName', elementId: FIELD_IDS.CLIENT_NAME },
        { key: 'clientEmail', elementId: FIELD_IDS.CLIENT_EMAIL },
        { key: 'clientAddress', elementId: FIELD_IDS.CLIENT_ADDRESS },
        { key: 'clientCountry', elementId: FIELD_IDS.CLIENT_COUNTRY },
        { key: 'clientState', elementId: FIELD_IDS.CLIENT_STATE },
        { key: 'invoiceNumber', elementId: FIELD_IDS.INVOICE_NUMBER },
        { key: 'invoiceCurrency', elementId: FIELD_IDS.INVOICE_CURRENCY },
        { key: 'billingSubTotal', elementId: FIELD_IDS.BILLING_SUB_TOTAL },
        { key: 'billingTax', elementId: FIELD_IDS.BILLING_TAX },
        { key: 'billingDiscountCalculation', elementId: FIELD_IDS.BILLING_DISCOUNT_CALCULATION },
        { key: 'balance', elementId: FIELD_IDS.BALANCE },
        { key: 'notes', elementId: FIELD_IDS.NOTES },
        { key: 'terms', elementId: FIELD_IDS.TERMS },
    ];
    const shouldUseImage = getOr(0, 'value.length', getElement(FIELD_IDS.UPLOAD)) > 0;

    return {
        // Base key value
        ...templates.reduce(
            (accumulator, { key, elementId }) => set(key, getElement(elementId).value, accumulator), {},
        ),

        // Additional custom values
        invoiceDateOfIssue: dateOfIssue.toDateString(),
        invoiceDueDate: dueDate.toDateString(),
        productTable: productsArray,
        taxTable: taxesArray,

        ...(shouldUseImage ? { image: imgUrl } : {}),
    };
}

function calculateLineTotal(price, quantity, discount = 0) {
    return ((price * quantity) * ((100 - discount) / 100)).toFixed(2);
}

export function billingPrice_keyPress(event) {
    const { value: price } = event.target;
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (quantityValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL).value = calculateLineTotal(price, quantityValue, discountValue);
    }
}

export function billingQuantity_keyPress(event) {
    const { value: quantity } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantity, discountValue);
    }
}

export function billingDiscount_keyPress(event) {
    const { value: discount } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);

    if (quantityValid && billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantityValue, discount);
    }
}

export function billingPrice_click(event) {
    const { value: price } = event.target;
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (quantityValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(price, quantityValue, discountValue);
    }
}

export function billingQuantity_click(event) {
    const { value: quantity } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantity, discountValue);
    }
}

export function billingDiscount_click(event) {
    const { value: discount } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);

    if (quantityValid && billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantityValue, discount);
    }
}

export function billingDiscount_change(event) {
    const { value: discount } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);

    if (quantityValid && billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantityValue, discount);
    }
}

export function billingQuantity_change(event) {
    const { value: quantity } = event.target;
    const {
        valid: billingPriceValid,
        value: billingPriceValue,
    } = getElement(FIELD_IDS.BILLING_PRICE);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (billingPriceValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(billingPriceValue, quantity, discountValue);
    }
}

export function billingPrice_change(event) {
    const { value: price } = event.target;
    const { value: quantityValue, valid: quantityValid } = getElement(FIELD_IDS.BILLING_QUANTITY);
    const { value: discountValue } = getElement(FIELD_IDS.BILLING_DISCOUNT);

    if (quantityValid) {
        getElement(FIELD_IDS.BILLING_LINE_TOTAL)
            .value = calculateLineTotal(price, quantityValue, discountValue);
    }
}

function clearTaxFields() {
    getElement(FIELD_IDS.INVOICE_TAX_TYPE).value = '';
    getElement(FIELD_IDS.INVOICE_TAX_RATE).value = '';
}

function clearBillingFields() {
    const arrayFields = [
        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
        FIELD_IDS.BILLING_DISCOUNT,
        FIELD_IDS.BILLING_LINE_TOTAL,
    ];

    arrayFields.forEach((field) => {
        getElement(field).value = '';
    });
}

function updateBillingRequiredProperty(updateValue) {
    const arrayFields = [
        FIELD_IDS.BULLING_PRODUCT_ITEM,
        FIELD_IDS.BILLING_DESCRIPTION,
        FIELD_IDS.BILLING_PRICE,
        FIELD_IDS.BILLING_QUANTITY,
        FIELD_IDS.BILLING_DISCOUNT,
        FIELD_IDS.BILLING_LINE_TOTAL,
    ];

    arrayFields.forEach((field) => {
        getElement(field).required = updateValue;
    });
}

function updateTaxRequiredProperty(updateValue) {
    getElement(FIELD_IDS.INVOICE_TAX_TYPE).required = updateValue;
    getElement(FIELD_IDS.INVOICE_TAX_RATE).required = updateValue;
}

function checkIfCollapseTable(nameTable) {
    const { data, collapse, expend } = getElement(nameTable);

    if (data.length === 0) {
        collapse();
    } else {
        expend();
    }
}

function addNewProductToRepeater() {
    const billingFieldsNotValid = checkBillingFields();
    // Case means the fields are valid
    if (billingFieldsNotValid) {
        productsArray.push({
            _id: generateId(),
            product: getElement(FIELD_IDS.BULLING_PRODUCT_ITEM).value,
            description: getElement(FIELD_IDS.BILLING_DESCRIPTION).value,
            price: getElement(FIELD_IDS.BILLING_PRICE).value,
            quantity: getElement(FIELD_IDS.BILLING_QUANTITY).value,
            discount: getElement(FIELD_IDS.BILLING_DISCOUNT).value,
            lineTotal: getElement(FIELD_IDS.BILLING_LINE_TOTAL).value,
        });

        // getElement('repeaterProductElement').data = productsArray;
        // getElement('repeaterProduct').expand();
        clearBillingFields();

        updateBillingRequiredProperty(false);
    }
}

export function addNewProduct_click() {
    ifUpdateBalanace = '';
    addNewProductToRepeater();
}

function addNewTaxToRepeater() {
    // const takFieldsNotValid = checkTaxFields();
    const isTaxTypeValid = getElement(FIELD_IDS.INVOICE_TAX_TYPE).valid && getElement(FIELD_IDS.INVOICE_TAX_TYPE).value !== "";
    const isTaxRateValid = getElement(FIELD_IDS.INVOICE_TAX_RATE).valid && getElement(FIELD_IDS.INVOICE_TAX_RATE).value !== "";

    const takFieldsNotValid = isTaxTypeValid && isTaxRateValid;
    if (takFieldsNotValid) {
        taxesArray.push({
            _id: generateId(),
            type: getElement('invoiceTaxType').value,
            rate: getElement('invoiceRate').value,
        });
       // getElement('repeaterTaxElement').data = taxesArray;
       // getElement('repeaterTax').expand();
        clearTaxFields();

        updateTaxRequiredProperty(false);
    }
}

export function addTaxbutton_click() {
    ifUpdateBalanace = '';
    const isTaxTypeValid = getElement(FIELD_IDS.INVOICE_TAX_TYPE).valid;
    const isTaxRateValid = getElement(FIELD_IDS.INVOICE_TAX_RATE).valid;
    if (isTaxTypeValid && isTaxRateValid) {
        addNewTaxToRepeater();
    }
}

function updateTaxUI() {
    const subTotal = getElement(FIELD_IDS.BILLING_SUB_TOTAL).value;
    const discount = getElement(FIELD_IDS.BILLING_DISCOUNT_CALCULATION).value;
    const value = (subTotal - discount).toString();
    if (value !== '') {
        const tax = taxesArray.reduce((accumulator, { rate: rowRate }) => {
            const rowTax = (Number(value) * Number(rowRate)) / 100;

            return accumulator + rowTax;
        }, 0);

        const taxRateSum = taxesArray.reduce((accumulator, { rate: rowRate }) => {
            const taxRate = Number(rowRate)

            return accumulator + taxRate;
        }, 0);

        getElement('billingTaxRate').text = taxRateSum ? `(${taxRateSum} %)` : `( %)`;

        getElement(FIELD_IDS.BILLING_TAX).value = tax.toFixed(2);
    } else {
        getElement('billingTaxRate').text = '0 %'
    }
}

function calculateSubTotal() {
    let subTotal = 0;
    let productPricesWithDiscount = 0;
    productsArray.forEach((row) => {
        subTotal += (Number(row.price) * Number(row.quantity));
        productPricesWithDiscount += Number(row.lineTotal);
    });
    getElement(FIELD_IDS.BILLING_SUB_TOTAL).value = Number(subTotal).toFixed(2);
    const discountCalculation = Number(subTotal - productPricesWithDiscount);
    getElement('billingDiscountCalculation').value = discountCalculation.toFixed(2);
    updateTaxUI();
}

function updateUIBalance() {
    const { value: billingSubTotal } = getElement(FIELD_IDS.BILLING_SUB_TOTAL);
    const { value: billingDiscount } = getElement(FIELD_IDS.BILLING_DISCOUNT_CALCULATION);
    const { value: billingTax } = getElement(FIELD_IDS.BILLING_TAX);

    const update = Number(billingSubTotal) - Number(billingDiscount) + Number(billingTax);

    getElement(FIELD_IDS.BALANCE).value = update.toFixed(2);
}

function updateBalance() {
    // addNewTaxToRepeater();
    // addNewProductToRepeater();
    calculateSubTotal();
    updateUIBalance();
}

export async function emailYourClientButton_click() {
    updateBalance();
    const checkIfValid = checkValidation();
    console.log('checkIfValid', checkIfValid)
    const isNotSpecialCharacters = checkValidationForSpecialChars();
    console.log('isNotSpecialCharacters', isNotSpecialCharacters);
    if (!checkIfValid || !isNotSpecialCharacters) {
        console.log('RETURN');
        let element = getElement('textForm');
        return;
    }
    const invoiceData = createPdfObjectData();
    openLightbox('Send_flow_to_client', {
        data: invoiceData,
    });
}

export async function downLoadInvoiceButton_click() {
    updateBalance();
    const checkIfValid = checkValidation();
    const isNotSpecialCharacters = checkValidationForSpecialChars();
    if (checkIfValid && isNotSpecialCharacters) {
        const invoiceData = createPdfObjectData();

        if (DEBUG_LOG) {
            console.log(invoiceData);
        }

        const payload = await downloadPDF(invoiceData);
        openLightbox('download_Flow');
        $w('#html1').postMessage(payload)
    } else {
        let element = getElement('textForm');
    }
}

export function balancButton_click() {
    // ifUpdateBalanace = true;
    updateBalance();
}

export function repeaterTax_itemReady_1($item, itemData) {
    $item('#type').value = itemData.type;
    $item('#rate').value = itemData.rate;
    $item('#deleteItemTax').onClick(() => {
        const indexInArray = taxesArray.findIndex((item) => item.type === itemData.type);
        taxesArray.splice(indexInArray, 1);
        getElement('repeaterTaxElement').data = taxesArray;
        checkIfCollapseTaxRepeater('repeaterTaxElement');
    });
}

function checkIfCollapseTaxRepeater(repeater) {
    let element = getElement(repeater);
    const { data } = element;

    if (data.length === 0) {
        getElement('repeaterTax').collapse();
    } else {
        getElement('repeaterTax').expand();
    }
}

export function repeaterProduct_itemReady_1($item, itemData) {
    $item('#product').value = itemData.product;
    $item('#description').value = itemData.description;
    $item('#price').value = itemData.price;
    $item('#quantity').value = itemData.quantity;
    $item('#discount').value = itemData.discount;
    $item('#lineTotal').value = itemData.lineTotal;
    $item('#deleteItemProduct').onClick(() => {
        const indexInArray = productsArray.findIndex((item) => item.product === itemData.product);
        productsArray.splice(indexInArray, 1);
        getElement('repeaterProductElement').data = productsArray;
        checkIfCollapseProductRepeater('repeaterProductElement');
    });
}

function checkIfCollapseProductRepeater(repeater) {
    let element = getElement(repeater);
    const { data } = element;

    if (data.length === 0) {
        getElement('repeaterProduct').collapse();
    } else {
        getElement('repeaterProduct').expand();
    }
}

export function anchorColorSwitch_viewportEnter() {
    if (formFactor !== 'Mobile') {
        getElement('anchorMenuWhite').show();
        getElement('anchorMenuBlack').hide();
    }
}

export function anchorColorSwitch_viewportLeave() {
    if (formFactor !== 'Mobile') {
        getElement('anchorMenuWhite').hide();
        getElement('anchorMenuBlack').show();
    }
}

async function getPictureUrl() {
    const uploadedFile = await getElement(FIELD_IDS.UPLOAD).startUpload();
    imgUrl = 'https://static.wixstatic.com/media/';
    imgUrl += uploadedFile.url.split('/')[3];
}

export async function uploadButton_change() {
    let files = $w("#uploadButton").value;
    if (files.length > 0) {
        getElement('loaderGif').show();
        await getPictureUrl();
        console.log("imgUrl:", imgUrl);

        getElement('imageLogo').src = imgUrl;
        getElement('loaderGif').hide();
    } else {
        getElement('imageLogo').src = 'https://static.wixstatic.com/media/4e13b1_a5c13bc3323e4fb996fc830592358302~mv2.jpg/v1/fill/w_180,h_180,al_c,lg_1,q_80/logo.webp';
        getElement('loaderGif').hide();
    }
}

export function clientCountry_change(event) {
    //Add your code for this event here: 
    if (event.target.value === 'United States')
        $w('#clientState').enable();
    else
        $w('#clientState').disable();
}

export function businessCountry_change(event) {
    //Add your code for this event here: 
    if (event.target.value === 'United States')
        $w('#businessState').enable();
    else
        $w('#businessState').disable();
}

export function linkedinSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.wix.com/tools/invoice-generator&title=Wix%20Invoice%20Generator&summary=I%20just%20made%20an%20invoice%20for%20my%20clients%20with%20Wix%20Invoice%20Generator.%20Check%20out%20this%20professional%20business%20tool%20and%20create%20your%20own%20invoice%20today!%20&source=`);
}

export function facebookSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://www.facebook.com/sharer/sharer.php?u=https%3A//www.wix.com/tools/invoice-generator`);
}

export function twitterSocial_click(event) {
    $w('#positionSocialLink').postMessage(`https://twitter.com/intent/tweet?text=I%20just%20made%20an%20invoice%20for%20my%20clients%20with%20Wix%20Invoice%20Generator.%20Check%20out%20this%20professional%20business%20tool%20and%20create%20your%20own%20invoice%20today!%20https%3A//www.wix.com/tools/invoice-generator`);
}

export function button13_click(event) {
    openLightbox('Send_Flow');
    //Add your code for this event here: 
}